module.exports = __webpack_public_path__ + "img/poe.22b9368b.png";